import emptyScreenIcon from "../../assets/images/EmptyScreen.png";

const EmptyScreen = ({
  moreContent,
  message,
  heading,
  icon = emptyScreenIcon,
  className,
  messageClassName,
  headingClassName,
  moreContentClassName,
  messageWidth,
  headingWidth,
}) => {
  return (
    <>
      <div
        className={`d-flex flex-column align-items-center justify-content-center gap-2 ${className}`}
        style={{ margin: "8rem" }}
      >
        <div>
          <img src={icon} alt="icon" className="" />
        </div>
        <span
          className={`fs-5 fw-bold text-center  ${headingClassName}`}
          style={{ width: headingWidth }}
        >
          {heading}
        </span>
        <span
          className={`fs12px fw-medium text-center ${messageClassName}`}
          style={{ color: "#7D7D7D", width: messageWidth }}
        >
          {message}
        </span>

        <div className={`custom-div ${moreContentClassName}`}>
          {moreContent}
        </div>
      </div>
    </>
  );
};

export default EmptyScreen;
